module.exports = __webpack_public_path__ + "img/score-0.64347114.png";